export const modalStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    placeItems: 'center',
  }

  